import React, { Component } from "react";
import {
  message,
  PageHeader,
  Spin,
  Row,
  Col,
  Divider,
  Select,
  Form as FormInitial,
  Tooltip,
} from "antd";
import {
  Form,
  FormItem,
  InputNumberItem,
  SelectItem,
  DatePickerItem,
  NotificacionPolizas,
  NotificacionMovimientosInventario,
  ButtonItem,
  ErrorItem,
  calcularMaxDisponible
} from "../../../../Components/Items";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import ElegirMarbetes from "../../Marbetes/ElegirMarbetes/ElegirMarbetes";
import ElegirLotes from "../../LotesCaducidades/ElegirLotes/ElegirLotes";
import ElegirAgrupaciones from "../../Agrupaciones/ElegirAgrupaciones/ElegirAgrupaciones";
import EnviarCorreoEntregarInsumosVenta from "./EnviarCorreoEntregarInsumosVenta/EnviarCorreoEntregarInsumosVenta";
import RutaPicking from "../../../../Components/RutaPicking";
import {
  CalculatorOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  CarOutlined,
  UserOutlined,
  ContactsOutlined,
  HourglassOutlined,
  CheckCircleOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
} from "@ant-design/icons";
import InfoCard from "../../../../Components/InfoCard";
import truncate6Decimals from "../../../../Components/truncate6Decimals";

const { Option } = Select;

moment.locale("es");

class EntregarInsumosVenta extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    datosVenta: undefined,
    todasInsumos: null,
    objetoInsumos: null,
    todasProyectos: null,
    objetoProyectos: null,
    modalCorreo: false,
    modalCorreoId: null,
    id: this.props.location.state.id,
    entregaId: null,
    colapsadoSinEntregar: false,
    colapsadoEntregados: true,
    filasConError: [],
    modalRutaPickingVisible: false,
    rutaPickingAlmacenes: [],
    pedidosSeleccionados: []
  };
  componentDidMount() {
    this.consultarTodo();
  }

  abrirModalCorreo(ventaId, entregaId) {
    this.setState({ modalCorreo: true, modalCorreoId: ventaId, entregaId: entregaId })
  }

  cerrarModalCorreo() {
    this.setState({ modalCorreo: false, modalCorreoId: null })
    this.atras();
  }

  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "proyectos/selectProyectos",
        { empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        if (res.data.status === 404) {
        } else {
          this.setState({ todasProyectos: res.data });
          this.setState({
            objetoProyectos: res.data.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.nombre}
                </Option>
              );
            }),
          });
        }
      });
    await axios
      .post(
        "ventas/datosVentaPRecibirP",
        {
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        {
          headers: this.props.headersToken,
        }
      )
      .then(async (res) => {
        if (res.data.success === 2) {
          this.setState({
            datosVenta: res.data.venta,
            pedidosSeleccionados: res.data?.venta?.pedidosIds || [],
            todasInsumos: res.data.insumos,
            objetoInsumos: res.data.insumos.map((value) => {
              return (
                <Option value={value._id} key={value._id}>
                  {value.stringBuscar}
                </Option>
              );
            }),
          });
          const insumosFormato = res.data.venta.insumos.map(value => {
            return { ...value, precioUnitarioAjustado: (value.precioUnitario * (1 - (value.descuento / 100))) }
          });
          this.formRef.current.setFieldsValue({ insumos: insumosFormato });

          // Consulta de inventarios en bulk
          const insumosBulk = insumosFormato.map((row, index) => {
            const insumoOriginal = res.data.insumos.find(i => i._id.toString() === row.insumoId.toString());
            return {
              index,
              insumoId: row.insumoId,
              proyectoId: row.proyectoId,
              inventariable: insumoOriginal?.inventariable,
              noPrincipal: insumoOriginal?.noPrincipal,
              insumoCompuesto: insumoOriginal?.insumoCompuesto,
              componentesKit: row.componentesKit,
            };
          });
          try {
            const resInventarios = await axios.post(
              "inventarios/inventarioInsumoProyectoBulk",
              { empresaId: this.props.empresaId, insumos: insumosBulk, ventaId: this.state.id, pedidosSeleccionados: res?.data?.venta?.pedidosIds, pedidoId: res?.data?.venta?.pedidoId },
              { headers: this.props.headersToken }
            );
            if (resInventarios.data?.results) {
              resInventarios.data.results.forEach(r => {
                insumosFormato[r.index].cantidadProyecto = r.cantidad !== null ? this.inventarioSinResiduo(r.cantidad) : "No inventariable";
              });
              this.formRef.current.setFieldsValue({ insumos: insumosFormato });
            }
          } catch (e) {
            console.error("Error al consultar inventario bulk", e);
          }
        } else {
          message.error(
            "Error no se encontro informacion de la venta"
          );
        }
      });
    this.setState({ loading: false });
  }

  // Vender por presentación deja residuos de redondeo en el inventario (12 piezas de una caja
  // dejan 0.0000000048 piezas) que se veían como existencia y como "Max". Se cortan a 6
  // decimales hacia abajo, nunca hacia arriba, para no ofrecer más de lo que el backend va a
  // aceptar. Solo cambia lo que se muestra; lo que no es número (inventario sin leer) pasa igual.
  inventarioSinResiduo(cantidad) {
    return typeof cantidad === "number" ? truncate6Decimals(cantidad) : cantidad;
  }

  // que ya valida la celda "Cantidad a entregar", para saber qué filas exceden lo permitido
  // (incluye inventario = 0). No altera ninguna validación ni variable existente.
  calcularFilasConErrorInventario(insumos = []) {
    return (insumos || []).reduce((acc, row, index) => {
      const maxDisabled = calcularMaxDisponible({
        cantidad: this.state.datosVenta?.insumos?.[index]?.cantidad,
        yaMovido: this.state.datosVenta?.insumos?.[index]?.entregado,
        cantidadProyecto: row?.cantidadProyecto,
      });
      if ((row?.entregar || 0) > maxDisabled) acc.push(index);
      return acc;
    }, []);
  }
  onFinishFailed(e) {
    this.setState({ filasConError: this.calcularFilasConErrorInventario(this.formRef.current?.getFieldValue('insumos') || []) });
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ filasConError: [] });
    let entregarTodos = 0;
    values.insumos = values.insumos.map(value => {
      let entregar = value.entregar ? value.entregar : 0
      entregarTodos += entregar
      return { ...value, entregar }
    })
    if (entregarTodos === 0) return message.info('Se neceitan cantidades para poder hacer esta operación')
    this.setState({ loading: true });
    axios
      .post(
        "ventas/entregarInsumos",
        {
          ...values,
          empresaId: this.props.empresaId,
          ventaId: this.state.id,
        },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(
            "Se han entregado insumos de la venta: " + res.data.codigo
          );
          NotificacionPolizas(res.data.polizasId)
          NotificacionMovimientosInventario(res.data.movimientosIds)
          this.formRef.current.resetFields();
          this.abrirModalCorreo(this.state.id, res.data.entregaId)
        } else if (res.data.success === 1) {
          message.error(res.data.message ? res.data.message : "No se pueden entregar los insumos");
        } else {
          message.error("Hubo un error y no se entregaron los insumos");
        }
      });
  }
  atras() {
    this.props.history.goBack();
  }
  abrirRutaPicking = () => {
    const form = this.formRef?.current;
    if (!form) return;
    const insumos = form.getFieldValue("insumos") || [];

    const pendientesPorProyecto = new Map();
    insumos.forEach((row, idx) => {
      const insumoVenta = this.state.datosVenta?.insumos?.[idx];
      const cantidad = Number(insumoVenta?.cantidad) || 0;
      const entregado = Number(insumoVenta?.entregado) || 0;
      const pendiente = cantidad - entregado;
      if (pendiente <= 0 || !row?.proyectoId || !row?.insumoId) return;

      const insumo = this.state.todasInsumos?.find((valorInsumo) => valorInsumo._id === row.insumoId);
      const llave = String(row.proyectoId);
      if (!pendientesPorProyecto.has(llave)) pendientesPorProyecto.set(llave, []);
      pendientesPorProyecto.get(llave).push({
        insumoId: row.insumoId,
        cantidad: pendiente,
        clave: insumo?.clave,
        descripcion: insumo?.descripcion,
      });
    });

    if (pendientesPorProyecto.size === 0) {
      message.info("No hay insumos pendientes de entregar");
      return;
    }

    const rutaPickingAlmacenes = Array.from(pendientesPorProyecto.entries()).map(([proyectoId, insumosPendientes]) => {
      const proyecto = this.state.todasProyectos?.find((valorProyecto) => valorProyecto._id === proyectoId);
      return { proyectoId, proyectoNombre: proyecto?.nombre, insumos: insumosPendientes };
    });

    this.setState({ modalRutaPickingVisible: true, rutaPickingAlmacenes });
  };

  cerrarRutaPicking = () => {
    this.setState({ modalRutaPickingVisible: false });
  };

  //Al confirmar la ruta, prefija "entregar" por fila con lo recolectado (topado al máximo permitido de esa
  //fila), igual que hace setMaxEntregarTodos - no toca el flujo de guardado existente. mapaCantidades viene
  //anidado por almacén: { [proyectoId]: { [insumoId]: cantidad } }, porque el mismo insumoId puede repetirse
  //en varios almacenes (filas distintas) con cantidades recolectadas distintas.
  onConfirmarRutaPicking = (mapaCantidadesPorProyecto) => {
    const form = this.formRef?.current;
    if (!form) return;
    const insumos = form.getFieldValue("insumos") || [];

    const nuevos = insumos.map((row, idx) => {
      const cantidadesDelProyecto = mapaCantidadesPorProyecto[String(row?.proyectoId)];
      const cantidadRecolectada = cantidadesDelProyecto?.[row?.insumoId];
      if (cantidadRecolectada === undefined) return row;

      const insumoVenta = this.state.datosVenta?.insumos?.[idx];
      const maxDisabled = calcularMaxDisponible({
        cantidad: insumoVenta?.cantidad,
        yaMovido: insumoVenta?.entregado,
        cantidadProyecto: row?.cantidadProyecto,
      });

      return { ...row, entregar: Number(Math.min(cantidadRecolectada, maxDisabled)) };
    });

    form.setFieldsValue({ insumos: nuevos });
    this.setState({ modalRutaPickingVisible: false });
  };
  async onChangeInsumoProyecto(value, key) {
    let arrayValue = await this.formRef.current.getFieldValue("insumos");
    let proyectoId = arrayValue[key].proyectoId;
    const insumoId = arrayValue[key].insumoId;
    const insumo = this.state.todasInsumos.find(
      (valueInsumos) => valueInsumos._id === insumoId
    );
    if (!insumo) return
    if (insumo.inventariable || insumo.insumoCompuesto) {
      await axios
        .post(
          "inventarios/inventarioInsumoProyecto",
          {
            proyectoId: proyectoId,
            insumoId: insumoId,
            ventaId: this.state.id,
            noPrincipal: insumo.noPrincipal,
            insumoCompuesto: insumo.insumoCompuesto,
            componentesKit: arrayValue[key].componentesKit,
            empresaId: this.props.empresaId,
            pedidoId: this.state.datosVenta?.pedidoId,
            pedidosSeleccionados: this.state.datosVenta?.pedidosIds,
          },
          { headers: this.props.headersToken }
        )
        .then((res) => {
          this.setState({ loading: false });
          arrayValue[key].cantidadProyecto = this.inventarioSinResiduo(res.data.cantidad);
        });
    } else {
      arrayValue[key].cantidadProyecto = "No inventariable";
    }
    this.formRef.current.setFieldsValue({
      insumos: arrayValue,
    });
  }
  abrirElegirMarbetes(value, marbetes, insumoId, proyectoId) {
    if (proyectoId) {
      this.setState({
        modalElegirMarbetes: true,
        modalElegirMarbetesIndex: value,
        modalElegirMarbetesMarbetes: marbetes || [],
        modalElegirMarbetesInsumoId: insumoId,
        modalElegirMarbetesProyectoId: proyectoId
      })
    } else {
      message.warning('Elegir un proyecto para elegir marbetes')
    }
  }
  cerrarElegirMarbetes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirMarbetesIndex].marbetes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirMarbetes: false,
      modalElegirMarbetesIndex: null,
      modalElegirMarbetesMarbetes: null,
      modalElegirMarbetesInsumoId: null,
      modalElegirMarbetesProyectoId: null
    })
  }
  abrirElegirLotes(value, lotes, insumoId, proyectoId, cantidad) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirLotes: true,
        modalElegirLotesIndex: value,
        modalElegirLotesLotes: lotes || [],
        modalElegirLotesInsumoId: insumoId,
        modalElegirLotesProyectoId: proyectoId,
        modalElegirLotesClienteId: clienteId,
        modalElegirLotesCantidad: cantidad
      })
    } else {
      message.warning('Elegir un proyecto para elegir lotes')
    }
  }
  cerrarElegirLotes(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirLotesIndex].lotes = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirLotes: false,
      modalElegirLotesIndex: null,
      modalElegirLotesLotes: null,
      modalElegirLotesInsumoId: null,
      modalElegirLotesProyectoId: null,
      modalElegirLotesClienteId: null,
      modalElegirLotesCantidad: null
    })
  }
  abrirElegirAgrupaciones(value, agrupaciones, insumoId, proyectoId) {
    const clienteId = this.formRef.current.getFieldValue('clienteId')
    if (proyectoId) {
      this.setState({
        modalElegirAgrupaciones: true,
        modalElegirAgrupacionesIndex: value,
        modalElegirAgrupacionesAgrupaciones: agrupaciones || [],
        modalElegirAgrupacionesInsumoId: insumoId,
        modalElegirAgrupacionesProyectoId: proyectoId,
        modalElegirAgrupacionesClienteId: clienteId
      })
    } else {
      message.warning('Elegir un proyecto para elegir agrupaciones')
    }
  }
  cerrarElegirAgrupaciones(value) {
    const insumos = this.formRef.current.getFieldValue('insumos')
    insumos[this.state.modalElegirAgrupacionesIndex].agrupaciones = value
    this.formRef.current.setFieldsValue({
      insumos: insumos
    })
    this.setState({
      modalElegirAgrupaciones: false,
      modalElegirAgrupacionesIndex: null,
      modalElegirAgrupacionesAgrupaciones: null,
      modalElegirAgrupacionesInsumoId: null,
      modalElegirAgrupacionesProyectoId: null,
      modalElegirAgrupacionesClienteId: null
    })
  }

  setMaxEntregarTodos = async () => {
    const form = this.formRef?.current;
    if (!form) return;
    this.setState({ loading: true });

    const insumos = form.getFieldValue("insumos") || [];

    const maxPorFila = insumos.map((row, idx) => calcularMaxDisponible({
      cantidad: this.state?.datosVenta?.insumos?.[idx]?.cantidad,
      yaMovido: this.state?.datosVenta?.insumos?.[idx]?.entregado,
      cantidadProyecto: row?.cantidadProyecto,
    }));

    const insumosConLotes = insumos
      .map((row, idx) => {
        const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
        if (!insumo?.lotesCaducidades || maxPorFila[idx] <= 0) return null;
        return { insumoId: row.insumoId, proyectoId: row.proyectoId, cantidad: maxPorFila[idx], _idx: idx };
      })
      .filter(Boolean);

    let resultadosMap = {};
    if (insumosConLotes.length > 0) {
      try {
        const res = await axios.post(
          "lotes/selectLotesDiponiblesMasivoRecomendadoConApartados",
          {
            empresaId: this.props.empresaId,
            insumos: insumosConLotes.map(({ insumoId, proyectoId, cantidad, _idx }) => ({ insumoId, proyectoId, cantidad, idx: _idx })),
            ventaId: this.state.id,
          },
          { headers: this.props.headersToken }
        );
        if (res.data.success === 2) {
          res.data.resultados.forEach((r) => {
            resultadosMap[r.idx] = r;
          });
        }
      } catch (e) {
        // Si falla, seguimos sin lotes automáticos
      }
    }

    const nuevos = insumos.map((row, idx) => {
      const resultado = resultadosMap[idx];
      let entregar = maxPorFila[idx];
      let extra = {};
      if (resultado) {
        entregar = Number(Math.min(entregar, resultado.cantidadCubierta));
        extra = { lotes: resultado.lotes };
      }
      return { ...row, entregar, ...extra };
    });

    form.setFieldsValue({ insumos: nuevos });
    this.setState({ loading: false });
  };

  renderEncabezado() {
    const venta = this.state.datosVenta;
    if (!venta) return null;
    const proyecto = venta.proyecto || {};
    const cliente = venta.cliente || {};
    const nombreCliente = cliente.nombre
      ? `${cliente.nombre} ${cliente.apellidoPaterno || ""} ${cliente.apellidoMaterno || ""}`.trim()
      : cliente.razonSocial;
    return (
      <Row style={{ marginBottom: 16 }}>
        <InfoCard
          title="PROYECTO"
          icon={<InfoCircleOutlined />}
          accentColor="#00BFD6"
          compact
          sections={[
            {
              title: "Información General",
              icon: <InfoCircleOutlined />,
              iconColor: "#00BFD6",
              lg: 12,
              items: [
                { label: "Nombre", value: proyecto.nombre || "-" },
                { label: "Descripción", value: proyecto.descripcion || "-" },
              ],
            },
            {
              title: proyecto.calle ? "Dirección" : "Vehículo",
              icon: proyecto.calle ? <EnvironmentOutlined /> : <CarOutlined />,
              iconColor: "#C9DF00",
              lg: 12,
              items: proyecto.calle
                ? [
                    { label: "Calle", value: `${proyecto.calle} #${proyecto.numeroCalle || "-"}` },
                  ]
                : [
                    { label: "Marca", value: proyecto.marca || "-" },
                    { label: "Modelo", value: proyecto.modelo || "-" },
                    { label: "Placas", value: proyecto.placas || "-" },
                  ],
            },
          ]}
          splitWith={{
            title: "CLIENTE",
            icon: <UserOutlined />,
            accentColor: "#FF6A0D",
            compact: true,
            sections: [
              {
                title: "Datos del Cliente",
                icon: <UserOutlined />,
                iconColor: "#FF6A0D",
                lg: 12,
                items: [
                  { label: "Nombre", value: nombreCliente || "-" },
                  { label: "RFC", value: cliente.rfc || "-" },
                  { label: "Correo", value: cliente.correo || "-" },
                  { label: "Teléfono", value: cliente.telefono || "-" },
                  { label: "Celular", value: cliente.celular || "-" },
                ],
              },
              {
                title: "Contacto",
                icon: <ContactsOutlined />,
                iconColor: "#00BFD6",
                lg: 12,
                items: [
                  { label: "Contacto", value: cliente.nombreContacto || "-" },
                  { label: "Tel. Contacto", value: cliente.telefonoContacto || "-" },
                  { label: "Correo Contacto", value: cliente.correoContacto || "-" },
                  { label: "Días de crédito", value: cliente.diasCredito || "-" },
                ],
              },
            ],
          }}
        />
      </Row>
    );
  }

  render() {
    const isMobile = window.innerWidth <= 1000;
    return (
      <>
        <PageHeader
          onBack={this.atras.bind(this)}
          title="Entregar Insumos sobre Venta"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <Row align="middle" gutter={16}>
              {this.props.moduloWms && (
                <Col>
                  <ButtonItem
                    className="botonAgregar"
                    icon={<EnvironmentOutlined />} 
                    cyan
                    onClick={this.abrirRutaPicking}
                  >
                    Generar ruta de picking
                  </ButtonItem>
                </Col>
              )}
              <Col>
                <h1>
                  Fecha:{" "}
                  {moment(this.state.datosVenta?.createdAt).format("LL")}
                </h1>
              </Col>
            </Row>
          }
        />
        <div className="card-background">
          <Spin spinning={this.state.loading}>
            <Form
              ref={this.formRef}
              name="entregarInsumosFactura"
              layout
              bottom={
                <ButtonItem
                  type="primary"
                  htmlType="submit"
                  style={{ display: "block", margin: "0 0 0 auto" }}
                >
                  Entregar
                </ButtonItem>
              }
              onFinish={this.onFinish.bind(this)}
              onFinishFailed={this.onFinishFailed.bind(this)}
              onValuesChange={(changedValues, allValues) => {
                if (this.state.filasConError.length > 0) {
                  this.setState({ filasConError: this.calcularFilasConErrorInventario(allValues.insumos) });
                }
              }}
            >
              {this.renderEncabezado()}
              <Divider style={{ marginBottom: 24, marginTop: 24}} />
              <Row >
                <Col span={8}></Col>
                <Col span={8} xs={24} sm={24} md={isMobile ? 24 : 12} lg={isMobile ? 24 : 8} xl={isMobile ? 24 : 8}>
                  <FormItem
                    label="Fecha de Entrega"
                    name="fechaEntrega"
                    required
                    margin
                    initialValue={moment()}
                  >
                    <DatePickerItem
                      placeholder="Fecha de Entrega"
                      allowClear={false}
                    />
                  </FormItem>
                </Col>
                <Col span={8}></Col>
              </Row>
              <FormInitial.List name="insumos">
                {(fields) => (
                  <>
                    <div className="tabla-insumos-venta tabla-sin-recorte">
                      <table className="table" style={{ backgroundColor: 'white' }}>
                        {fields.length > 0 ? (
                          <thead>
                            <tr>
                              <th className="th-border" style={{ width: "20%" }}>
                                Insumo
                              </th>
                              <th className="th-border" style={{ width: "20%" }}>
                                Proyecto
                              </th>
                              <th className="th-border" style={{ width: "10%" }}>
                                Cantidad Proyecto
                              </th>
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Precio Unitario
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Pedida
                                </th>}
                              {!isMobile &&
                                <th className="th-border" style={{ width: "10%" }}>
                                  Cantidad Entregada
                                </th>
                              }

                              <th className="th-border" style={{ width: "10%", textAlign: "center" }}>
                                Cantidad a entregar
                                <Tooltip title='Poner maximos.'>
                                  <CalculatorOutlined onClick={this.setMaxEntregarTodos} style={{ marginLeft: '5px', color: 'green' }} />
                                </Tooltip>
                              </th>
                              <th className="th-border" style={{ width: "10%" }}>
                                Acción
                              </th>
                            </tr>
                          </thead>
                        ) : null}
                        {(() => {
                          const pendientes = [];
                          const entregados = [];
                          fields.forEach((field, arrayKey) => {
                            const insumoVenta = this.state.datosVenta?.insumos?.[arrayKey];
                            const cantidad = Number(insumoVenta?.cantidad) || 0;
                            const entregado = Number(insumoVenta?.entregado) || 0;
                            if (cantidad - entregado <= 0) {
                              entregados.push({ field, arrayKey, isEntregado: true });
                            } else {
                              pendientes.push({ field, arrayKey, isEntregado: false });
                            }
                          });
                          const renderFila = ({ field, arrayKey, isEntregado }) => {
                            const { key, name, fieldKey, ...restField } = field;
                            return (
                          <FormItem key={fieldKey} noStyle shouldUpdate>
                            {({ getFieldValue }) => {
                              const row = (getFieldValue('insumos') || [])[arrayKey];
                              const lotes = row?.lotes || [];
                              const insumo = this.state.todasInsumos?.find(i => i._id === row?.insumoId);
                              const necesitaLotes = insumo?.lotesCaducidades;
                              const entregar = row?.entregar || 0;
                              const sumLotes = lotes.reduce((s, l) => s + (l.cantidadRequerida || 0), 0);
                              // Con tolerancia, igual que el modal ElegirLotes y que el backend. La
                              // comparacion exacta pintaba el renglon de rojo por residuos de flotante
                              // cuando la cantidad se reparte entre varios lotes.
                              const isRed = necesitaLotes && entregar > 0 && Math.abs(sumLotes - entregar) > 0.0001;
                              const tieneErrorInventario = (this.state.filasConError || []).includes(arrayKey);
                              return (
                          <tbody style={isEntregado && !isRed && !tieneErrorInventario ? { backgroundColor: '#f5f5f5', opacity: 0.85 } : {}}>
                            <tr
                              className={tieneErrorInventario ? 'fila-insumo-conflicto' : ''}
                              style={!tieneErrorInventario && isRed ? { backgroundColor: '#ffccc7' } : {}}
                            >
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "insumoId"]}
                                  fieldKey={[fieldKey, "insumoId"]}
                                  required
                                  noStyle
                                >
                                  <SelectItem
                                    sinBorde
                                    style={{ width: "100%" }}
                                    placeholder="Insumo"
                                    disabled
                                  >
                                    {this.state.objetoInsumos}
                                  </SelectItem>
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <FormItem
                                  shouldUpdate={(prev, curr) =>
                                    prev.proyectoId !== curr.proyectoId
                                  }
                                  noStyle
                                >
                                  {({ getFieldValue }) => {
                                    const arrayValue = getFieldValue("insumos");
                                    const insumoValue = arrayValue[arrayKey]
                                    return (
                                      <FormItem
                                        {...restField}
                                        name={[name, "proyectoId"]}
                                        fieldKey={[fieldKey, "proyectoId"]}
                                        required
                                        noStyle
                                      >
                                        <SelectItem
                                          sinBorde
                                          style={{ width: "100%" }}
                                          placeholder="Proyecto"
                                          disabled={insumoValue?.apartado > 0}
                                          onChange={(value) =>
                                            this.onChangeInsumoProyecto(
                                              value,
                                              arrayKey
                                            )
                                          }
                                        >
                                          {this.state.objetoProyectos}
                                        </SelectItem>
                                      </FormItem>
                                    );
                                  }}
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidadProyecto"]}
                                  required
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    disabled
                                    placeholder="Cantidad en Proyecto"
                                  />
                                </FormItem>
                              </td>
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "precioUnitarioAjustado"]}
                                  fieldKey={[fieldKey, "precioUnitarioAjustado"]}
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Precio Unitario"
                                    disabled
                                    dineroDisabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "cantidad"]}
                                  fieldKey={[fieldKey, "cantidad"]}
                                  required
                                  number
                                  noStyle
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Vendida"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              {!isMobile && <td className="td-border">
                                <FormItem
                                  {...restField}
                                  name={[name, "entregado"]}
                                  fieldKey={[fieldKey, "entregado"]}
                                  required
                                  numberCero
                                  noStyle
                                  initialValue={0}
                                >
                                  <InputNumberItem
                                    sinBorde
                                    placeholder="Cantidad Entregada"
                                    disabled
                                  />
                                </FormItem>
                              </td>}
                              <td className="td-border">
                                <FormItem shouldUpdate noStyle>
                                  {({ getFieldValue }) => {
                                    // arrayKey en ambas lecturas: antes la venta se
                                    // indexaba con fieldKey y cantidadProyecto con
                                    // arrayKey. Hoy coinciden, pero son dos indices
                                    // distintos de Form.List.
                                    const filaVenta =
                                      this.state.datosVenta?.insumos?.[arrayKey];
                                    const insumos = getFieldValue("insumos");
                                    const maxDisabled = calcularMaxDisponible({
                                      cantidad: filaVenta?.cantidad,
                                      yaMovido: filaVenta?.entregado,
                                      cantidadProyecto: insumos?.[arrayKey]?.cantidadProyecto,
                                    });
                                    return (
                                      <FormItem
                                        {...restField}
                                        name={[name, "entregar"]}
                                        fieldKey={[fieldKey, "entregar"]}
                                        numberCero
                                        noStyle
                                        max={maxDisabled}
                                        type="number"
                                      >
                                        <InputNumberItem
                                          sinBorde
                                          placeholder={"Max: " + maxDisabled}
                                        />
                                      </FormItem>
                                    );
                                  }}
                                </FormItem>
                              </td>
                              <td className="td-border">
                                <Row>
                                  <Col span={24}>
                                    <FormItem
                                      noStyle
                                      shouldUpdate
                                    >
                                      {({ getFieldValue }) => {
                                        let arrayValue = getFieldValue("insumos");
                                        let mostrarMarbetes = false
                                        let mostrarLotes = false
                                        let mostrarAgrupaciones = false
                                        let insumoId
                                        let proyectoId
                                        if (arrayValue[arrayKey]?.insumoId && this.state.todasInsumos) {
                                          const insumo = this.state.todasInsumos.find(
                                            (valueInsumos) => valueInsumos._id === arrayValue[arrayKey].insumoId
                                          );
                                          mostrarMarbetes = insumo?.marbetes
                                          mostrarLotes = insumo?.lotesCaducidades
                                          mostrarAgrupaciones = insumo?.agrupaciones
                                          insumoId = insumo?._id
                                          proyectoId = arrayValue[arrayKey]?.proyectoId
                                        }
                                        if (mostrarMarbetes) {
                                          return (
                                            <ButtonItem
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirMarbetes(arrayKey, arrayValue[arrayKey].marbetes, insumoId, proyectoId)
                                              }}
                                            >
                                              Mar.
                                            </ButtonItem>
                                          )
                                        }
                                        if (mostrarAgrupaciones) {
                                          return (
                                            <ButtonItem
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirAgrupaciones(arrayKey, arrayValue[arrayKey].agrupaciones, insumoId, proyectoId)
                                              }}
                                            >
                                              Agr.
                                            </ButtonItem>
                                          )
                                        }
                                        if (mostrarLotes) {
                                          return (
                                            <ButtonItem
                                              type="primary"
                                              size='small'
                                              style={{ width: '80%', marginLeft: '10%' }}
                                              block
                                              onClick={() => {
                                                this.abrirElegirLotes(arrayKey, arrayValue[arrayKey].lotes, insumoId, proyectoId, arrayValue[arrayKey].entregar)
                                              }}
                                            >
                                              {this.props.taxidermia ? "Animales" : "Lotes"}
                                            </ButtonItem>
                                          )
                                        }
                                      }}
                                    </FormItem>
                                  </Col>
                                </Row>
                              </td>
                            </tr>
                          </tbody>
                              );
                            }}
                          </FormItem>
                            );
                          };
                          return (
                            <>
                              {pendientes.length > 0 && (
                                <tbody>
                                  <tr>
                                    <td colSpan="8" style={{ padding: 0, border: 'none' }}>
                                      <div
                                        onClick={() => this.setState({ colapsadoSinEntregar: !this.state.colapsadoSinEntregar })}
                                        style={{
                                          background: "#e6f7ff", borderLeft: "4px solid #1890ff",
                                          padding: "10px 15px", cursor: "pointer", display: "flex", justifyContent: "space-between",
                                          fontWeight: "bold", color: "#0050b3", marginTop: 10, marginBottom: 5
                                        }}
                                      >
                                        <span><HourglassOutlined style={{ marginRight: 8 }} /> Sin entregar / Incompletos ({pendientes.length})</span>
                                        <span>{this.state.colapsadoSinEntregar ? <><CaretDownOutlined /> Mostrar</> : <><CaretUpOutlined /> Ocultar</>}</span>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                              {!this.state.colapsadoSinEntregar && pendientes.map(renderFila)}

                              {entregados.length > 0 && (
                                <tbody>
                                  <tr>
                                    <td colSpan="8" style={{ padding: 0, border: 'none' }}>
                                      <div
                                        onClick={() => this.setState({ colapsadoEntregados: !this.state.colapsadoEntregados })}
                                        style={{
                                          background: "#f6ffed", borderLeft: "4px solid #52c41a",
                                          padding: "10px 15px", cursor: "pointer", display: "flex", justifyContent: "space-between",
                                          fontWeight: "bold", color: "#237804", marginTop: 10, marginBottom: 5
                                        }}
                                      >
                                        <span><CheckCircleOutlined style={{ marginRight: 8 }} /> Entregados completamente ({entregados.length})</span>
                                        <span>{this.state.colapsadoEntregados ? <><CaretDownOutlined /> Mostrar</> : <><CaretUpOutlined /> Ocultar</>}</span>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              )}
                              {!this.state.colapsadoEntregados && entregados.map(renderFila)}
                            </>
                          );
                        })()}
                      </table>
                    </div>
                  </>
                )}
              </FormInitial.List>
            </Form>
          </Spin>
        </div>
        <ElegirMarbetes
          visible={this.state.modalElegirMarbetes}
          cerrarElegirMarbetes={this.cerrarElegirMarbetes.bind(this)}
          marbetes={this.state.modalElegirMarbetesMarbetes}
          insumoId={this.state.modalElegirMarbetesInsumoId}
          proyectoId={this.state.modalElegirMarbetesProyectoId}
        />
        <ElegirLotes
          visible={this.state.modalElegirLotes}
          cerrarElegirLotes={this.cerrarElegirLotes.bind(this)}
          lotes={this.state.modalElegirLotesLotes}
          insumoId={this.state.modalElegirLotesInsumoId}
          proyectoId={this.state.modalElegirLotesProyectoId}
          clienteId={this.state.modalElegirLotesClienteId}
          ventaId={this.state.id}
          cantidad={this.state.modalElegirLotesCantidad}
          pedidosSeleccionados={this.state.pedidosSeleccionados}
          modoCantidad="exacta"
        />
        <ElegirAgrupaciones
          visible={this.state.modalElegirAgrupaciones}
          cerrarElegirAgrupaciones={this.cerrarElegirAgrupaciones.bind(this)}
          agrupaciones={this.state.modalElegirAgrupacionesAgrupaciones}
          insumoId={this.state.modalElegirAgrupacionesInsumoId}
          proyectoId={this.state.modalElegirAgrupacionesProyectoId}
          clienteId={this.state.modalElegirAgrupacionesClienteId}
          ventaId={this.state.id}
        />
        <EnviarCorreoEntregarInsumosVenta
          visible={this.state.modalCorreo}
          id={this.state.modalCorreoId}
          entregaId={this.state.entregaId}
          cerrarMandarCorreo={this.cerrarModalCorreo.bind(this)}
          empresaId={this.props.empresaId}
          padre={2}
        />
        <RutaPicking
          visible={this.state.modalRutaPickingVisible}
          onClose={this.cerrarRutaPicking}
          onConfirmar={this.onConfirmarRutaPicking}
          empresaId={this.props.empresaId}
          headersToken={this.props.headersToken}
          almacenes={this.state.rutaPickingAlmacenes}
          titulo={`Ruta de picking — Venta ${this.state.datosVenta?.serieNumero || ""}`}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
    moduloWms: state.empresa.moduloWms,
  };
};

export default connect(mapStateToProps)(EntregarInsumosVenta);
